import { rei } from "@/services/api"

class MigracaoService {
  static migracaoByCartorio (cartorio_id, params) {
    return rei.post(`migracao`, { cartorio_id,  ...params }).then(res => res.data)
  }

  static getMigracaoByCartorio (cartorioId) {
    const params = {
      cartorio_id: cartorioId
    }

    return rei.get(`show-migracao-by-cartorio-id`, { params }).then(res => res.data)
  }
}

export default MigracaoService
